import { ScanBarcode, Zap, Layers, Keyboard, X } from "lucide-react";
import { useI18n } from "@/lib/i18n.jsx";

const KEY = "calofay_whatsnew_barcode_v1";
const LAUNCH = "2026-11-02T00:00:00Z";

// Only users who signed up before the new scanner shipped, once per device.
export function shouldShowBarcodeNews(user) {
  try {
    if (localStorage.getItem(KEY) === "1") return false;
    return !user?.created_at || user.created_at < LAUNCH;
  } catch { return false; }
}

const markSeen = () => { try { localStorage.setItem(KEY, "1"); } catch {} };

const POINTS = [
  { Icon: Zap, ar: "يقرأ الباركود تلقائياً بمجرد ما توجّه الكاميرا — بدون تصوير", en: "Reads the barcode instantly — just point the camera, no photo needed" },
  { Icon: Layers, ar: "امسح أكثر من منتج ورا بعض وأضفهم كلهم لنفس الوجبة", en: "Scan several products in a row and add them all to the same meal" },
  { Icon: Keyboard, ar: "وتقدر تكتب رقم الباركود يدوياً إذا حبيت", en: "You can also type the barcode number manually" },
];

export default function WhatsNewBarcode({ open, onClose, onTry }) {
  const { lang } = useI18n();
  const en = lang === "en";
  if (!open) return null;
  const close = () => { markSeen(); onClose?.(); };
  const tryIt = () => { markSeen(); onTry?.(); };
  return (
    <div className="fixed inset-0 z-[120] bg-black/55 backdrop-blur-sm flex items-end sm:items-center justify-center p-0 sm:p-4" onClick={close} data-testid="whatsnew-barcode-modal">
      <div onClick={(e) => e.stopPropagation()} dir={en ? "ltr" : "rtl"}
        className="bg-white w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl overflow-hidden shadow-2xl animate-in slide-in-from-bottom-4 fade-in duration-300">
        <div className="orange-gradient text-white px-6 pt-6 pb-7 relative">
          <button onClick={close} className="absolute top-4 end-4 w-8 h-8 rounded-full bg-white/20 flex items-center justify-center" data-testid="whatsnew-barcode-close" aria-label={en ? "Close" : "إغلاق"}>
            <X className="w-4 h-4" />
          </button>
          <div className="w-14 h-14 rounded-2xl bg-white/20 flex items-center justify-center mb-3">
            <ScanBarcode className="w-8 h-8" />
          </div>
          <div className="text-xs font-bold opacity-90">{en ? "NEW" : "جديد"}</div>
          <h2 className="text-2xl font-black leading-tight mt-0.5">{en ? "A faster barcode scanner" : "مسح الباركود صار أسرع"}</h2>
        </div>
        <div className="px-6 py-5 space-y-3.5">
          {POINTS.map(({ Icon, ar, en: e }) => (
            <div key={e} className="flex items-start gap-3">
              <div className="w-9 h-9 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center shrink-0"><Icon className="w-4.5 h-4.5" /></div>
              <p className="text-sm text-neutral-700 leading-relaxed pt-1.5">{en ? e : ar}</p>
            </div>
          ))}
        </div>
        <div className="px-6 pb-6 space-y-2" style={{ paddingBottom: "max(1.5rem, env(safe-area-inset-bottom))" }}>
          <button onClick={tryIt} className="w-full orange-gradient text-white font-bold py-4 rounded-full shadow-floating active:scale-[0.98]" data-testid="whatsnew-barcode-try">
            {en ? "Try it now" : "جرّبه الآن"}
          </button>
          <button onClick={close} className="w-full text-sm text-neutral-500 py-2" data-testid="whatsnew-barcode-later">
            {en ? "Later" : "لاحقاً"}
          </button>
        </div>
      </div>
    </div>
  );
}
